module.exports = __webpack_public_path__ + "static/img/bg-pt.7390bd35.webp";